module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-high-street.json
// module id = 408
// module chunks = 14822362812536